"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const common = {
  activeColor: 'interactive.primary.active',
  color: 'text.link',
  disabledColor: 'disabled.2',
  fontWeight: 'normal',
  hoverColor: 'interactive.primary.hover',
  textDecoration: 'underline!important',
  textStyle: 'body'
};
const theme = {
  primary: { ...common,
    textStyle: 'bodyBold'
  },
  secondary: { ...common
  },
  tertiary: { ...common,
    textStyle: 'metaBold'
  },
  meta: { ...common,
    textStyle: 'meta'
  }
};
exports.theme = theme;
//# sourceMappingURL=Link.theme.js.map